// gkc_hash_code : 01EV64EDXCZTX8ZCEMHJHDQ126
import React, { Suspense, lazy } from 'react';
import history from 'utils/helper/history';
import { Router, Switch, Redirect, Route } from 'react-router-dom';
import { ROUTERS } from 'utils/constant/routers';
import Loading from 'components/primitive/Loading';
import DefaultLayout from 'components/compound/Layout/DefaultLayout';

const ResetPassword = lazy(() => import('./modules/reset-password'));
const NotFound = lazy(() => import('./modules/not-found'));
const Home = lazy(() => import('./modules/home'));
const DeleteAccount = lazy(() => import('modules/delete-account'));
const Privacy = lazy(() => import('modules/safety/privacy'));
const TermOfUse = lazy(() => import('modules/safety/term'));
const CommercialTransactions = lazy(() =>
  import('modules/safety/commercial_transactions'),
);
const DeleteAccountSuccess = lazy(() =>
  import('modules/delete-account/success'),
);
const Magazines = lazy(() => import('modules/magazines'));
const Spot = lazy(() => import('modules/spot'));
const QRCode = lazy(() => import('modules/qr-code'));
const NotFoundContent = lazy(() => import('modules/not-found-content'));
const QRCodeNotFound = lazy(() => import('modules/qr-code-not-found'));

export default function AppRouter() {
  return (
    <Router history={history}>
      <Suspense fallback={<Loading />}>
        <Switch>
          <Route exact path={ROUTERS.HOME} component={Home} />
          <Route path={ROUTERS.RESET_PASSWORD} component={ResetPassword} />
          <Route
            exact
            path={ROUTERS.DELETE_ACCOUNT}
            component={DeleteAccount}
          />
          <Route
            exact
            path={ROUTERS.DELETE_ACCOUNT_SUCCESS}
            component={DeleteAccountSuccess}
          />
          <Route exact path={ROUTERS.PRIVACY} component={Privacy} />
          <Route exact path={ROUTERS.TERM_OF_USE} component={TermOfUse} />
          <Route
            exact
            path={ROUTERS.COMERCIAL}
            component={CommercialTransactions}
          />
          <Route path={ROUTERS.HEALTH_CHECK} component={null} />
          <DefaultLayout exact path={ROUTERS.MAGAZINES} component={Magazines} />
          <DefaultLayout exact path={ROUTERS.SPOT} component={Spot} />
          <Route
            component={QRCode}
            path={[ROUTERS.QR_CODE, ROUTERS.QR_CODE_WEB_SERVICE]}
          />
          <Route component={QRCodeNotFound} path={ROUTERS.QRCODE_NOT_FOUND} />
          <Route component={NotFoundContent} path={ROUTERS.NOT_FOUND_CONTENT} />
          <Route component={NotFound} path={ROUTERS.NOT_FOUND} />
          <Route component={NotFound} />
          <Redirect to={ROUTERS.NOT_FOUND} />
        </Switch>
      </Suspense>
    </Router>
  );
}
